module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/light-bulb.b0a3a89c3adbf921.gif";